import React from 'react';

const EmptyAmenityState = () => {
  return (
    <div className="flex items-center justify-center h-64 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
      <div className="text-center">
        <div className="text-4xl mb-4 text-gray-400">📅</div>
        <p className="text-lg text-gray-600 font-medium">Please select an amenity</p>
        <p className="text-sm text-gray-500 mt-2">
          Choose an amenity from the dropdown above to view available booking times
        </p>
      </div>
    </div>
  );
};

export default EmptyAmenityState;